import React, { FC, ReactNode, useState } from 'react';
import styled from 'styled-components';

import AddNewIvrModal from 'src/presentation/components/pages/ivr/components/NewIvrModal';
import CopyIcon from '@ad-scripts/presentation/components/common/icons/copy';
import { Tooltip } from 'src/presentation/components/agent_desktop_components';
import useCopyIvr from '../../hooks/useCopyIvr';

type CopyIvrProps = {
  item: {
    id: string;
    version: number;
    name: string;
    description: string;
  };
  description?: string | ReactNode;
  submitText?: string;
  errors?: any[];
};

const DEFAULT_DESCRIPTION = (
  <>
    Creating a new copy will put this IVR in the
    <br />
    Inactive tab until you associate a valid phone
    <br />
    number. What do you want to call it?
  </>
);

const CopyIvr: FC<CopyIvrProps> = ({
  item,
  errors = [],
  description = DEFAULT_DESCRIPTION,
  submitText = 'Duplicate',
}) => {
  const [isCopyModalVisible, setIsCopyModalVisible] = useState(false);
  const openModal = () => setIsCopyModalVisible(true);
  const handleCancel = () => setIsCopyModalVisible(false);
  const onCopy = useCopyIvr({ closeModal: handleCancel, params: item });

  return (
    <>
      <CopyButton data-aid={`copyButton-${item.id}`} onClick={openModal}>
        <Tooltip message="Duplicate" style={{ left: '5px' }} margin={13}>
          <CopyIcon />
        </Tooltip>
      </CopyButton>
      {isCopyModalVisible && (
        <AddNewIvrModal
          errors={errors}
          title={`Duplicating ${item.name || item.description}`}
          description={description}
          submitText={submitText}
          onCancel={handleCancel}
          onSubmit={onCopy}
        />
      )}
    </>
  );
};

const CopyButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  visibility: hidden;
  color: ${p => p.theme.colors.gray500};
  cursor: pointer;
  & svg {
    height: 16px;
  }

  &:hover {
    color: ${p => p.theme.colors.green400};
  }
`;

export { CopyIvr };
